import { css } from "@emotion/react";
// import logoImage from "../../../static/evalight.png";

export function PhoenixLogo() {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        padding: 20px 0 40px 0;
      `}
    >
      {/* <img
        src={logoImage}
        alt="Evalight Logo"
        css={css`
            height: 80px;
            width: auto;
            object-fit: contain;
            filter: drop-shadow(0 0 15px rgba(20, 186, 182, 0.4));
            transition: transform 0.3s ease;
            
            &:hover {
                transform: scale(1.05);
            }
        `}
      /> */}
      <div
        css={css`
            font-family: 'Outfit', 'Inter', sans-serif;
            font-size: 42px;
            font-weight: 800;
            letter-spacing: 8px;
            margin-right: -8px;
            text-align: center;
            background: linear-gradient(
                90deg, 
                #14BAB6 0%, 
                #00ADEE 33%, 
                #FFFFFF 50%, 
                #00ADEE 66%, 
                #14BAB6 100%
            );
            background-size: 200% auto;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            animation: shine 4s linear infinite;
            filter: drop-shadow(0 0 8px rgba(20, 186, 182, 0.3));

            @keyframes shine {
                to {
                    background-position: 200% center;
                }
            }
        `}
      >
        EVALIGHT
      </div>
      <div
        css={css`
            height: 2px;
            width: 140px;
            background: linear-gradient(90deg, transparent, #14BAB6, transparent);
            opacity: 0.6;
            margin-top: -4px;
        `}
      />
    </div>
  );
}
